<script>
import axios from 'axios'
import GoogleMap from '@/components/googleMap'
import MAP_STOP_POINT03 from '@/assets/map_icon/map_stop_point3.png'
import { mapState } from 'vuex'
import { StringUtil } from '@/utils/StringUtil'
export default {
  data () {
    return {
      windowType: '',
      title: '停留所を登録',
      viewModel: {
        stationName: '',
        stationId: '',
        addressName: '',
        address: '',
        stationLat: '',
        stationLng: '',
        note: '',
        createUser: '',
        transportKind: 0,
        officeFlag: 0,
      },
      mapId: 'mapSave',
      centerPoint: {
        lat: 35.709,
        lng: 139.731
      },
      zoom: 12,
      changeRowTittle: '地点名称',
      changeRowValue: ''
    }
  },
  props: { },
  computed: {
    ...mapState({
      lnglat: state => state.lnglat
    })
  },
  watch: {
    'viewModel' (newVal) {
      this.viewModel = newVal
    }
  },
  methods: {
    saveStationData () {
      var paramaterObj = {
        viewModelData: StringUtil.trim(this.viewModel)
      }
      axios.post('station/saveStationData', paramaterObj).then(response => {
        if (response.status === 200) {
          var windowType = sessionStorage.getItem('windowType')
          if (windowType === '1') {
            this.$router.push({ path: '/StationList' })
          } else {
            sessionStorage.setItem('stationViewModel', JSON.stringify(this.viewModel))
            this.$router.push({ path: '/StationDetail' })
          }
        }
      }).catch(function (error) {
        var windowType = sessionStorage.getItem('windowType')
        if (windowType === '1') {
          this.$router.push({ path: '/StationList' })
        } else {
          sessionStorage.setItem('stationViewModel', JSON.stringify(this.viewModel))
          this.$router.push({ path: '/StationDetail' })
          console.log(error)
        }
      })
      this.isShow = false
    },

    initiGoogleMap () {
      this.$refs.gMap.initializeGoogleMap().then(() => {
        const center = {
          lng: Number(this.viewModel.stationLng),
          lat: Number(this.viewModel.stationLat)
        }
        this.$refs.gMap.map.setCenter(center)
        this.$refs.gMap.map.setZoom(this.zoom)
        const imgSize = { width: 52, height: 76 }
        let markPositions = {
          label: 0,
          lng: this.viewModel.stationLng,
          lat: this.viewModel.stationLat,
          icon: MAP_STOP_POINT03
        }
        this.$refs.gMap.addSingleMaker(markPositions, imgSize, null, null)
      }).catch(error => {
        console.log(error)
      })
    },
    addSingleMaker () {

    }
  },
  mounted () {
    this.windowType = sessionStorage.getItem('windowType')
    if (this.windowType === '2') {
      this.title = '停留所を編集'
      this.changeRowTittle = '停留所ID'
    }
  },
  components: { GoogleMap }
}
</script>

<template>
  <div class="col-md-12 column">
    <div class="modal fade" id="modal-container-staySave" role="dialog" data-backdrop="static" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><img height="30px" src="@/assets/X.png" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;"/></button>
            <strong class="modal-title F3-M-27" id="myModalLabel">
              {{title}}
            </strong>
          </div>
          <div class="modal-body">
            <div class="row clearfix">
              <div class="col-md-6 column">
                <table class="table table-bordered window-table">
                  <tbody>
                    <tr>
                      <td class="td-key">運行区分</td>
                      <td class="td-value tooLong" v-show="viewModel.transportKind==0">区域内</td>
                      <td class="td-value tooLong" v-show="viewModel.transportKind==1">区域外</td>
                    </tr>
                    <tr>
                      <td class="td-key">停留所区分</td>
                      <td class="td-value tooLong" v-show="viewModel.officeFlag==0">停留所</td>
                      <td class="td-value tooLong" v-show="viewModel.officeFlag==1">事務所</td>
                    </tr>
                    <tr>
                      <td class="td-key">停留所名</td>
                      <td class="td-value tooLong">{{viewModel.stationName}}</td>
                    </tr>
                    <tr v-if="windowType == '1'" style="display:none">
                      <td class="td-key">{{changeRowTittle}}</td>
                      <td class="td-value">{{changeRowValue}}</td>
                    </tr>
                    <tr v-else>
                      <td class="td-key">{{changeRowTittle}}</td>
                      <td class="td-value">{{changeRowValue}}</td>
                    </tr>
                    <tr>
                      <td class="td-key">所在地</td>
                      <td class="td-value">{{viewModel.address}}</td>
                    </tr>
                    <tr>
                      <td class="td-key">緯度</td>
                      <td class="td-value">{{viewModel.stationLat}}</td>
                    </tr>
                    <tr>
                      <td class="td-key">経度</td>
                      <td class="td-value">{{viewModel.stationLng}}</td>
                    </tr>
                    <tr>
                      <td style="height:200px" class="td-key">コメント</td>
                      <td class="td-value tooLong">{{viewModel.note}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-md-6 column">
                <div class="mapCss">
                  <GoogleMap ref="gMap" :center-point="centerPoint" :map-id="mapId">
                  </GoogleMap>
                </div>
              </div>
            </div>
            <div>
              <div class="row clearfix">
                <button class="window-button" data-dismiss="modal" @click="saveStationData">確定</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-dialog {
    top: 20%;
    width: 1200px;
    margin-top: -120px;
}
.modal-header {
    border-bottom: 0px;
}
.modal-title {
    font-size: 28px;
}
.modal-body {
    padding-left: 40px;
    padding-right: 40px;
}
.window-table {
    font-size: 16px;
    border: 1px solid #959595;
}
.table-bordered > tbody > tr > td {
    border: 1px solid #959595;
}
.td-title {
    background-color: #797979;
    color: #fff;
    font-size: 22px;
}
.td-key {
    width: 30%;
    background-color: #dddddd;
}
.table > tbody > tr > td {
    height: 50px;
    vertical-align: middle;
}
.table > tbody > tr > .td-value {
    padding-left: 30px;
}
.td-value {
    text-align: left;
    border: 1px solid #959595;
}
.window-button {
    width: 450px;
    height: 50px;
    border-radius: 10px;
    margin: 15px 0;
    font-size: 2em;
    color: #fff;
    background-color: #717171;
}
.close {
    opacity: 1;
}
.mapCss {
    margin-left: -15px;
}
.tooLong {
    word-wrap: break-word;
    word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/stationSaveWindowMask.vue